
export const verifyNumberType = {
    REQUEST: 'VERIFY_NUMBER_REQUEST',
    SUCCESS: 'VERIFY_NUMBER_SUCCESS',
    FAILURE: 'VERIFY_NUMBER_FAILURE',
}